import $ from 'jquery';

class SelectM {
    constructor() {
        this.score = $("#score");
        this.lyric = $("#lyric");
        this.video = $("#video");
        this.s_btn = $("#s-btn");
        this.l_btn = $("#l-btn");
        this.v_btn = $("#v-btn");
        this.check_s = true;
        this.check_l = false;
        this.check_v = false;

        if(this.score) {
            this.events();
        }
    }

    // events
    events() {
        this.s_btn.on('click', this.selectS.bind(this));
        this.l_btn.on('click', this.selectL.bind(this));
        this.v_btn.on('click', this.selectV.bind(this));
    }

    // methods
    selectS(e) {
        if(this.check_s) {

        } else if(this.check_l) {
            this.check_l = false;
            this.l_btn.removeClass('active');
            this.score.removeClass('hide');
            this.lyric.addClass('hide');
            this.check_s = true;
            this.s_btn.addClass('active');
        } else if(this.check_v) {
            this.check_v = false;
            this.v_btn.removeClass('active');
            this.score.removeClass('hide');
            this.video.addClass('hide');
            this.check_s = true;
            this.s_btn.addClass('active');
        }
    }

    selectL(e) {
        if(this.check_l) {

        } else if(this.check_s) {
            this.check_s = false;
            this.s_btn.removeClass('active');
            this.score.addClass('hide');
            this.lyric.removeClass('hide');
            this.check_l = true;
            this.l_btn.addClass('active');
        } else if(this.check_v) {
            this.check_v = false;
            this.v_btn.removeClass('active');
            this.lyric.removeClass('hide');
            this.video.addClass('hide');
            this.check_l = true;
            this.l_btn.addClass('active');
        }
    }

    selectV(e) {
        if(this.check_v) {

        } else if(this.check_s) {
            this.check_s = false;
            this.s_btn.removeClass('active');
            this.score.addClass('hide');
            this.video.removeClass('hide');
            this.check_v = true;
            this.v_btn.addClass('active');
        } else if(this.check_l) {
            this.check_l = false;
            this.l_btn.removeClass('active');
            this.lyric.addClass('hide');
            this.video.removeClass('hide');
            this.check_v = true;
            this.v_btn.addClass('active');
        }
    }


}

export default SelectM;